import { embeddedFormsIcon } from './icons';
import embeddedFormsBlockMeta from './block.json';
import { getBlockLabelByName } from '@helpers/utils';
import edit from './edit';
import './style.scss';

const {
  blocks: { registerBlockType },
} = wp;
const { name, ...settings } = embeddedFormsBlockMeta;

const attributes = {
  ...settings.attributes,
};
registerBlockType(name, {
  ...settings,
  icon: embeddedFormsIcon,
  attributes,
  edit,
  __experimentalLabel: (attributes) =>
    getBlockLabelByName(attributes, settings.title),
});
